import { ASSETS } from "../lib/brand";
import { useReveal } from "../hooks/useReveal";

export const Editorial = () => {
  const leftRef = useReveal();
  const rightRef = useReveal();
  const captionRef = useReveal();

  return (
    <section
      id="editorial"
      data-testid="editorial-section"
      className="py-24 md:py-40 border-b border-black/100"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-12 md:mb-20">
          <div>
            <div className="label-eyebrow mb-4">Editorial · Vol. II</div>
            <h2 className="font-display text-[2.6rem] md:text-7xl leading-[0.95] tracking-[-0.015em]">
              Kept in <span className="italic">frame.</span>
            </h2>
          </div>
          <div className="label-eyebrow hidden md:block opacity-60">
            Cambridge · GTA · KW
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-10 items-start">
          {/* Left — tall portrait */}
          <div
            ref={leftRef}
            className="col-span-12 md:col-span-5 md:mt-0 reveal"
          >
            <div className="overflow-hidden aspect-[4/5] bg-black/5">
              <img
                src={ASSETS.cambridge}
                alt="Editorial — kept in frame, Cambridge"
                data-testid="editorial-image-2"
                loading="lazy"
                className="editorial-img w-full h-full object-cover"
              />
            </div>
            <div className="flex items-center justify-between pt-4">
              <span className="label-micro">N° 02 — Kept in frame</span>
              <span className="label-micro italic opacity-60">
                Cambridge · Afternoons
              </span>
            </div>
          </div>

          {/* Right — offset, slightly lower, larger */}
          <div
            ref={rightRef}
            className="col-span-12 md:col-span-6 md:col-start-7 md:mt-24 reveal reveal-delay-2"
          >
            <div className="overflow-hidden aspect-[4/5] md:aspect-[3/4] bg-black/5">
              <img
                src={ASSETS.editorial3}
                alt="Editorial — a night out in the GTA"
                data-testid="editorial-image-3"
                loading="lazy"
                className="editorial-img w-full h-full object-cover"
              />
            </div>
            <div className="flex items-center justify-between pt-4">
              <span className="label-micro">N° 03 — Evenings</span>
              <span className="label-micro italic opacity-60">GTA · Night run</span>
            </div>
          </div>
        </div>

        <div
          ref={captionRef}
          className="mt-16 md:mt-20 flex items-center justify-center reveal"
          data-testid="editorial-footer"
        >
          <a
            href="#reviews"
            className="label-micro link-underline opacity-70"
          >
            See what clients are saying →
          </a>
        </div>
      </div>
    </section>
  );
};
